/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetConditionParams,
  GetConditionsByResourceIdParams,
  GetConditionsByResourceObjectIdParams,
  SimpleResourceObjectCondition
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetConditionsUrl = () => {




  return `/api/ResourceObjectCondition/GetConditions`
}

export const getConditions = async ( options?: Parameters<typeof customInstance>[1]): Promise<SimpleResourceObjectCondition[]> => {

  return customInstance<SimpleResourceObjectCondition[]>(getGetConditionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConditionsQueryKey = () => {
    return [
    `/api/ResourceObjectCondition/GetConditions`
    ] as const;
    }


export const getGetConditionsQueryOptions = <TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditions>>> = ({ signal }) => getConditions({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConditionsQueryResult = NonNullable<Awaited<ReturnType<typeof getConditions>>>
export type GetConditionsQueryError = ErrorType<unknown>


export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditions>>,
          TError,
          Awaited<ReturnType<typeof getConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditions>>,
          TError,
          Awaited<ReturnType<typeof getConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditions<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditions>>> = ({ signal }) => getConditions({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetConditionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConditions>>>
export type GetConditionsSuspenseQueryError = ErrorType<unknown>


export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionsSuspense<TData = Awaited<ReturnType<typeof getConditions>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionUrl = (params: GetConditionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectCondition/GetCondition?${stringifiedParams}` : `/api/ResourceObjectCondition/GetCondition`
}

export const getCondition = async (params: GetConditionParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleResourceObjectCondition> => {

  return customInstance<SimpleResourceObjectCondition>(getGetConditionUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConditionQueryKey = (params?: GetConditionParams,) => {
    return [
    `/api/ResourceObjectCondition/GetCondition`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConditionQueryOptions = <TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(params: GetConditionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCondition>>> = ({ signal }) => getCondition(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConditionQueryResult = NonNullable<Awaited<ReturnType<typeof getCondition>>>
export type GetConditionQueryError = ErrorType<unknown>


export function useGetCondition<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCondition>>,
          TError,
          Awaited<ReturnType<typeof getCondition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCondition<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCondition>>,
          TError,
          Awaited<ReturnType<typeof getCondition>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCondition<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCondition<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(params: GetConditionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCondition>>> = ({ signal }) => getCondition(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetConditionSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCondition>>>
export type GetConditionSuspenseQueryError = ErrorType<unknown>


export function useGetConditionSuspense<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionSuspense<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionSuspense<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionSuspense<TData = Awaited<ReturnType<typeof getCondition>>, TError = ErrorType<unknown>>(
 params: GetConditionParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCondition>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionsByResourceObjectIdUrl = (params?: GetConditionsByResourceObjectIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectCondition/GetConditionsByResourceObjectId?${stringifiedParams}` : `/api/ResourceObjectCondition/GetConditionsByResourceObjectId`
}

export const getConditionsByResourceObjectId = async (params?: GetConditionsByResourceObjectIdParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleResourceObjectCondition[]> => {

  return customInstance<SimpleResourceObjectCondition[]>(getGetConditionsByResourceObjectIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConditionsByResourceObjectIdQueryKey = (params?: GetConditionsByResourceObjectIdParams,) => {
    return [
    `/api/ResourceObjectCondition/GetConditionsByResourceObjectId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConditionsByResourceObjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsByResourceObjectIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>> = ({ signal }) => getConditionsByResourceObjectId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConditionsByResourceObjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>>
export type GetConditionsByResourceObjectIdQueryError = ErrorType<unknown>


export function useGetConditionsByResourceObjectId<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetConditionsByResourceObjectIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditionsByResourceObjectId>>,
          TError,
          Awaited<ReturnType<typeof getConditionsByResourceObjectId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceObjectId<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditionsByResourceObjectId>>,
          TError,
          Awaited<ReturnType<typeof getConditionsByResourceObjectId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceObjectId<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionsByResourceObjectId<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsByResourceObjectIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionsByResourceObjectIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsByResourceObjectIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>> = ({ signal }) => getConditionsByResourceObjectId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetConditionsByResourceObjectIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>>
export type GetConditionsByResourceObjectIdSuspenseQueryError = ErrorType<unknown>


export function useGetConditionsByResourceObjectIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params: undefined |  GetConditionsByResourceObjectIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceObjectIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceObjectIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionsByResourceObjectIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError = ErrorType<unknown>>(
 params?: GetConditionsByResourceObjectIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceObjectId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsByResourceObjectIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionsByResourceIdUrl = (params: GetConditionsByResourceIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ResourceObjectCondition/GetConditionsByResourceId?${stringifiedParams}` : `/api/ResourceObjectCondition/GetConditionsByResourceId`
}

export const getConditionsByResourceId = async (params: GetConditionsByResourceIdParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleResourceObjectCondition[]> => {

  return customInstance<SimpleResourceObjectCondition[]>(getGetConditionsByResourceIdUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetConditionsByResourceIdQueryKey = (params?: GetConditionsByResourceIdParams,) => {
    return [
    `/api/ResourceObjectCondition/GetConditionsByResourceId`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetConditionsByResourceIdQueryOptions = <TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsByResourceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditionsByResourceId>>> = ({ signal }) => getConditionsByResourceId(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConditionsByResourceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getConditionsByResourceId>>>
export type GetConditionsByResourceIdQueryError = ErrorType<unknown>


export function useGetConditionsByResourceId<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditionsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getConditionsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceId<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConditionsByResourceId>>,
          TError,
          Awaited<ReturnType<typeof getConditionsByResourceId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceId<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionsByResourceId<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsByResourceIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetConditionsByResourceIdSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConditionsByResourceIdQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConditionsByResourceId>>> = ({ signal }) => getConditionsByResourceId(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetConditionsByResourceIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConditionsByResourceId>>>
export type GetConditionsByResourceIdSuspenseQueryError = ErrorType<unknown>


export function useGetConditionsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConditionsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConditionsByResourceIdSuspense<TData = Awaited<ReturnType<typeof getConditionsByResourceId>>, TError = ErrorType<unknown>>(
 params: GetConditionsByResourceIdParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getConditionsByResourceId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConditionsByResourceIdSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






